/**
 * Unattended-display route detection — used by the app-update flow.
 *
 * Signage player surfaces run full-screen on kiosks / ScreenCloud displays
 * with nobody at the keyboard, so an "update available — refresh" prompt can
 * never be actioned there. When a newer deploy is detected on one of these
 * routes the app reloads itself instead (see the auto-apply effect in
 * `app.ts`). Attended signage pages (the preview hub, setup wizard, pairing
 * entry) are deliberately NOT matched — reloading under someone mid-pairing
 * would lose their input.
 */

/**
 * True when `url` is a full-screen signage PLAYER surface (`/signage/play`
 * or `/signage/s/:type`). Accepts router URLs (`/signage/play?t=…`) and raw
 * location hashes (`#/signage/play`).
 */
export function isUnattendedSignageUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  const path = url.replace(/^#/, '').split('?')[0];
  return path.startsWith('/signage/play') || path.startsWith('/signage/s/');
}
